export const sendEtrackerSubjectClickEvent = (event, category, object, action) => {
  if (typeof window !== "undefined" && window && window._etracker && window._etracker.sendEvent && window.et_UserDefinedEvent) {
    const _etracker = window._etracker;
    _etracker.sendEvent(new window.et_UserDefinedEvent(object, category, action));
  }
}